export const chats = {
  chatListChatIfoAttachmentsText: 'Anhang gesendet',
  chatListChatNoMessagesText: 'Noch keine Nachrichten',
  chatArchivedTitle: 'Archivierte Chats',
  chatsCreatePrivateCurtainTitle: 'Neuer Chat',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Suchen',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Erstellen',
  chatCreateButtonTitle: 'Weiter',
  chatCreateNewGroupHeader: 'Neue Gruppe',
  chatGroupNameInputTitle: 'Gruppenname',
  chatLogoTitle: 'Bearbeiten',
  chatCreateGroupButtonTitle: 'Gruppe erstellen',
  chatRequiredFieldsAlert: 'Gruppenname muss angegeben werden!',
  chatsCreateGroupChatLongTitleAlertText: 'Bitte verwende einen kürzeren Titel!',
  chatsCreateGroupChatLBigImageAlertText: 'Bitte wähle ein kleineres Bild!',
  chatsNewChatInputPlaceholder: 'Nachricht schreiben',
  chatsNewChatAddedBigImageAlertText: 'Bitte wähle ein kleineres Bild!',
  chatOwnersArchiveOptionText: 'Archivieren',
  chatOwnersEditGroupOptionText: 'Bearbeiten',
  chatOwnersManageGroupOptionText: 'Mitglieder verwalten',
  chatOwnersChangeGroupOptionText: 'Gruppenbesitzer ändern',
  chatOwnersLeaveGroupOptionText: 'Verlassen',
  chatOwnersDeleteGroupOptionText: 'Chat löschen',
  chatpopupArchivedTitle: 'Chat archivieren',
  chatpopupArchivedDescription: 'Sind Sie sicher?',
  chatArchiveGroupButtonTitleYes: 'Bestätigen',
  chatArchiveGroupButtonTitleCancel: 'Abbrechen',
  chatEditGroupHeader: 'Chat bearbeiten',
  chatEditGroupEditLogoTitle: 'Bearbeiten',
  chatEditGroupButtonTitle: 'Speichern',
  chatGroupEditAlertText: 'Speichern erfolgreich!',
  chatManageGroupHeader: 'Verwalten',
  chatManageGroupButtonTitle: 'Mitglied hinzufügen',
  chatManageGroupSaveButtonTitle: 'Speichern',
  chatAddUsersGroupHeader: 'Mitglieder hinzufügen',
  chatAddUsersGroupButtonTitle: 'Bestätigen',
  chatAddUsersGroupSearchInputPlaceholder: 'Suchen',
  chatOwnershipTransferHeader: 'Eigentumsübertragung',
  chatOwnershipTransferSearchInputPlaceholder: 'Suchen',
  chatOwnershipTransferButtonTitle: 'Bestätigen',
  chatOwnerMarkText: '(du)',
  chatOwnershipTransferAlertText: 'Eigentum übertragen!',
  chatOwnerLeaveGroupTitle: 'Gruppe verlassen',
  chatOwnerLeaveGroupDescription: 'Sie sind Gruppenbesitzer, daher müssen Sie zuerst einen neuen Besitzer wählen, bevor Sie gehen.',
  chatOwnerLeaveGroupButtonTitleYes: 'Wählen',
  chatOwnerLeaveGroupButtonTitleNo: 'Abbrechen',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Archivieren',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Chat-Mitglieder',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Verlassen',
  chatsGroupChatMemberCurtainTitle: 'Chat-Mitglieder',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Suchen',
  chatsGroupChatMemberCurtainOwnerMarkText: '(Besitzer)',
  chatsGroupChatLeavePopupTitle: 'Verlassen',
  chatsGroupChatLeavePopupText: 'Sind Sie sicher?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Abbrechen',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Bestätigen',
  chatDeleteGroupTitle: 'Chat löschen',
  chatDeleteGroupDescription: 'Chat und Verlauf werden für alle Teilnehmer gelöscht. Fortfahren?',
  chatDeleteGroupButtonTitleYes: 'Bestätigen',
  chatDeleteGroupButtonTitleNo: 'Abbrechen',
  chatsPrivateChatCurtainArchOptionTitle: 'Archivieren',
  chatsEditMessage: 'Nachricht bearbeiten',
  chatsCopyMessage: 'Nachricht kopieren',
  chatsDeleteMessage: 'Nachricht löschen',
  chatsSelectMessage: 'Nachricht auswählen',
  chatMarkTextEdit: '(bearbeitet)',
  chatCopyMessageAlertText: 'Nachricht kopiert!',
  chatDeleteMessageTitle: 'Nachricht löschen',
  chatDeleteMessageDescription: 'Diese Nachricht löschen?',
  chatDeleteMessageButtonTitleYes: 'Bestätigen',
  chatDeleteMessageButtonTitleNo: 'Abbrechen',
  chatSelectButtonDelete: 'Abbrechen',
  chatSelectButtonNo: 'Löschen',
  chatDeleteMessagesTitle: 'Nachrichten löschen',
  chatDeleteMessagesDescription: 'Diese Nachrichten löschen?',
  chatDeleteMessagesButtonTitleYes: 'Bestätigen',
  chatDeleteMessagesButtonTitleNo: 'Abbrechen',
  chatArchiveButtonRestore: 'Wiederherstellen',
  chatArchiveButtonNo: 'Löschen',
  chatNoUsersCurtainTitle: 'Hoppla!',
  chatsNoUsersCurtainText:
    'Es scheint, dass außer dir keine anderen Benutzer vorhanden sind. Lade Freunde ein, um mit dem Chatten zu beginnen.',
  chatsNoUsersCurtainCancelButtonTitle: 'Abbrechen',
  chatsNoUsersCurtainCopyButtonTitle: 'App-Link kopieren',
  chatsAppLinkCopiedAlertText: 'Link kopiert!',
  chatsTooFewUsers: 'Bitte wähle mindestens einen Benutzer aus, um mit dem Chatten zu beginnen!',
  chatsError: 'Etwas ist schiefgegangen!'
}
